import React, {Fragment, useEffect, useState} from "react";
import {NavLink} from "react-router-dom";

// Material-UI Core
import {makeStyles} from "@material-ui/core/styles";
import Card from "../Card/Card";
import CardHeader from "../Card/CardHeader";
import CardIcon from "../Card/CardIcon";
import CardFooter from "../Card/CardFooter";

// Material-UI Icon
import ExitToAppIcon from "@material-ui/icons/ExitToApp";
import EventNoteIcon from "@material-ui/icons/EventNote";
import MailIcon from "@material-ui/icons/Mail";
import AssignmentTurnedInIcon from "@material-ui/icons/AssignmentTurnedIn";
import CompareArrowsIcon from "@material-ui/icons/CompareArrows";

// Custom Style
import styles from "../../styles/jss/components/dashboardCard/dashboardCardStyle";

// Fetch Data
import {documentSubmissionSearch} from "../../dataSource/documentSubmission";
import {getUnreadRfiCount} from "../../dataSource/rfi";
import {getUnreadTransmittalCount} from "../../dataSource/transmittal";
import {useSelector} from "react-redux";

const useStyles = makeStyles(styles);

const DashboardCard = (props) => {
    const classes = useStyles();
    const {cardModuleName, cardModulePath, parentModuleName} = props;

    const userSitesRedux = useSelector((state) => state.userSitesRedux);
    const [circulationCount, setCirculationCount] = useState(0);
    const [documentSubmissionCount, setDocumentSubmissionCount] = useState(0);
    const [rfiCount, setRfiCount] = useState(0);
    const [xmtlCount, setXmtlCount] = useState(0);
    const store = require("store");
    const userCategoryCode = store.get("user_category_code") || "";

    useEffect(()=>{
        let userSiteRedux = userSitesRedux !== null ? userSitesRedux.find(s => Number(s.site_seq) === Number(localStorage.getItem("site"))) : null
        setCirculationCount(userSiteRedux ? userSiteRedux['hasUnreadCirculation'] : 0)
    },[userSitesRedux])

    const unreadCount = async (data) => {
        let count = 0;

        await Promise.all(
            data.map((res) => {
                if (!res.is_read) {
                    count++;
                }
            })
        );

        return count;
    };

    const unreadRFIRemoveDuplicates = async (data) => {
        let countRFI = [];

        await Promise.all(
            data.map((res) => {
                if (
                    res.RCPT_CATEGORY === "SECONDAPPROVER" &&
                    res.NOTICESECONDAPV === "Y"
                ) {
                    if (countRFI.indexOf(res.RFI_SEQ) === -1) {
                        countRFI.push(res.RFI_SEQ);
                    }
                }
                if (
                    res.RCPT_CATEGORY === "THIRDAPPROVER" &&
                    res.NOTICETHIRDAPV === "Y"
                ) {
                    if (countRFI.indexOf(res.RFI_SEQ) === -1) {
                        countRFI.push(res.RFI_SEQ);
                    }
                }
                if (
                    res.RCPT_CATEGORY === "CONSULTANT" ||
                    res.RCPT_CATEGORY === "ARCHITECT"
                ) {
                    if (countRFI.indexOf(res.RFI_SEQ) === -1 && res.IS_SENT === "Y") {
                        countRFI.push(res.RFI_SEQ);
                    }
                }
                if (userCategoryCode === "SUPPLIER" || userCategoryCode === "SUBCON") {
                    if (countRFI.indexOf(res.RFI_SEQ) === -1 && res.IS_DRAFT === "Y") {
                        countRFI.push(res.RFI_SEQ);
                    }
                }
                if (res.RCPT_CATEGORY === "CC" && res.IS_SENT === "Y") {
                    if (countRFI.indexOf(res.RFI_SEQ) === -1) {
                        countRFI.push(res.RFI_SEQ);
                    }
                }
                if (
                    countRFI.indexOf(res.RFI_SEQ) === -1 &&
                    res.RCPT_CATEGORY !== "CC" &&
                    res.RCPT_CATEGORY !== "SECONDAPPROVER" &&
                    res.RCPT_CATEGORY !== "THIRDAPPROVER" &&
                    res.RCPT_CATEGORY !== "CONSULTANT" &&
                    res.RCPT_CATEGORY !== "ARCHITECT"
                ) {
                    if (countRFI.indexOf(res.RFI_SEQ) === -1) {
                        countRFI.push(res.RFI_SEQ);
                    }
                }
            })
        );
        return countRFI.length;
    };

    const unreadTransmittalRemoveDuplicates = async (data) => {
        let countXMTL = [];

        await Promise.all(
            data.map((res) => {
                if (
                    res.RCPT_CATEGORY === "SECONDAPPROVER" &&
                    res.NOTICESECONDAPV === "Y"
                ) {
                    if (countXMTL.indexOf(res.XMTL_SEQ) === -1) {
                        countXMTL.push(res.XMTL_SEQ);
                    }
                }
                if (
                    res.RCPT_CATEGORY === "THIRDAPPROVER" &&
                    res.NOTICETHIRDAPV === "Y"
                ) {
                    if (countXMTL.indexOf(res.XMTL_SEQ) === -1) {
                        countXMTL.push(res.XMTL_SEQ);
                    }
                }
                if (res.RCPT_CATEGORY === "TOEXTERNAL" || res.RCPT_CATEGORY === "CC") {
                    if (
                        countXMTL.indexOf(res.XMTL_SEQ) === -1 &&
                        res.IS_TRANSMITTED === "Y"
                    ) {
                        countXMTL.push(res.XMTL_SEQ);
                    }
                }

                if (
                    countXMTL.indexOf(res.XMTL_SEQ) === -1 &&
                    res.RCPT_CATEGORY !== "CC" &&
                    res.RCPT_CATEGORY !== "SECONDAPPROVER" &&
                    res.RCPT_CATEGORY !== "THIRDAPPROVER" &&
                    res.RCPT_CATEGORY !== "TOEXTERNAL"
                ) {
                    if (countXMTL.indexOf(res.XMTL_SEQ) === -1) {
                        countXMTL.push(res.XMTL_SEQ);
                    }
                }
            })
        );
        return countXMTL.length;
    };

    useEffect(() => {
        if (cardModulePath === "/circulation") {
            // getCirculation().then(async (res) => {
            //   setCirculationCount(await unreadCount(res.data));
            // });

        } else if (cardModulePath === "/submission") {
            documentSubmissionSearch({stage_seq: 1}).then((res) => {
                setDocumentSubmissionCount(res.data.length);
            });
        } else if (cardModulePath === "/rfi") {
            getUnreadRfiCount().then(async (res) => {
                setRfiCount(await unreadRFIRemoveDuplicates(res.data));
            });
        } else if (cardModulePath === "/transmittal") {
            getUnreadTransmittalCount().then(async (res) => {
                setXmtlCount(await unreadTransmittalRemoveDuplicates(res.data));
            });
        }
    }, []);

    return (
        <Fragment>
            <Card>
                <CardHeader color="info" stats icon>
                    {cardModulePath === "/circulation" ? (
                        <CardIcon color="purple">
                            <MailIcon/>
                        </CardIcon>
                    ) : cardModulePath === "/submission" ? (
                        <CardIcon color="red">
                            <AssignmentTurnedInIcon/>
                        </CardIcon>
                    ) : cardModulePath === "/rfi" ? (
                        <CardIcon color="green">
                            <CompareArrowsIcon/>
                        </CardIcon>
                    ) : cardModulePath === "/transmittal" ? (
                        <CardIcon color="blue">
                            <CompareArrowsIcon/>
                        </CardIcon>
                    ) : cardModulePath === "/pil" ? (
                        <CardIcon color="yellow">
                            <EventNoteIcon/>
                        </CardIcon>
                    ) : (
                        ""
                    )}
                    <div style={{height: "80px"}}>
                        <p className={classes.cardCategory}>
                            {parentModuleName !== "" ? parentModuleName : cardModuleName}
                        </p>
                        <span className={classes.cardSubCategory}>
              {parentModuleName !== "" ? cardModuleName : ""}
            </span>
                        <h3 className={classes.cardTitle}>
                            {cardModulePath === "/circulation"
                                ? circulationCount
                                : cardModulePath === "/submission"
                                    ? documentSubmissionCount
                                    : cardModulePath === "/rfi"
                                        ? rfiCount
                                        : cardModulePath === "/transmittal"
                                            ? xmtlCount
                                            : cardModulePath === "/pil"
                                                ? ""
                                                : 0}
                            {cardModulePath === "/circulation" ||
                            cardModulePath === "/rfi" ||
                            cardModulePath === "/transmittal" ? (
                                <small> (UNREAD)</small>
                            ) : cardModulePath === "/submission" ? (
                                <small> (PENDING)</small>
                            ) : (
                                <small></small>
                            )}
                        </h3>
                    </div>
                </CardHeader>

                <CardFooter stats>
                    <div className={classes.stats}>
                        <ExitToAppIcon/>
                        <NavLink
                            to={cardModulePath}
                            className={classes.activeLinkProperties}
                        >
                            View {cardModuleName}
                        </NavLink>
                    </div>
                </CardFooter>
            </Card>
        </Fragment>
    );
};

export default DashboardCard;
